import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { CalculationType } from '../../../enums/calculation-type.enum';
import { JointCalcService } from 'src/app/Modules/idms/components/plant-manager/services/joint-calc-service.service';

@Component({
    selector: 'app-tightening-method',
    templateUrl: './tightening-method.component.html',
    styleUrls: ['./tightening-method.component.scss'],
    standalone: false,
})
export class TighteningMethodComponent implements OnInit {
    @Input() cssClass;
    @Input() form: UntypedFormGroup;
    @Input() enable: boolean;
    @Input()
    set calculationType(value: string | number) {
        this._calculationType = value;
        if (this._calculationType == CalculationType.Clamp) {
            this.stateOptions = [{ label: 'Torque', value: 'Torque' }];
            this.setDefaultCalcMethod();
        }
    }
    get calculationType(): string | number {
        return this._calculationType;
    }
    stateOptions: any[];
    tooltip_position = 'above';
    _calculationType: string | number;

    constructor(
        private globalEmittersService: GlobalEmittersService,
        private router: Router,
        private jointCalcService: JointCalcService
    ) {
        if (this.router.url == '/informate/clamp/false' || this.router.url == '/informate/clamp/true') {
            this.stateOptions = [{ label: 'Torque', value: 'Torque' }];
        } else {
            this.stateOptions = [
                { label: 'Torque', value: 'Torque' },
                { label: 'Tension', value: 'Tension' },
            ];
        }
    }

    ngOnInit(): void {
        this.form.markAllAsTouched();
        this.form.get('calcMethod').valueChanges.subscribe((res) => {
            if (res) {
                this.jointCalcService.selectedTighteningMethod.next(res);
                this.globalEmittersService.tighteningMethod.next(res);
            }
        });

        if (this.jointCalcService.isPipeCode) {
            this.setDefaultCalcMethod();
        }
    }

    private setDefaultCalcMethod(): void {
        const defaultCalcMethod = this.stateOptions?.[0]?.value;
        if (!defaultCalcMethod || !this.form?.get('calcMethod')) {
            return;
        }

        this.form.get('calcMethod').setValue(defaultCalcMethod);
    }
}
